import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import styles from '../ConversationDetails.module.scss';
export const TypingIndicator = ({ isTyping }) => {
    return (_jsx("div", Object.assign({ className: classnames({
            [styles.typingOverlay]: true,
            [styles.typingOverlayTyping]: isTyping,
        }) }, { children: isTyping && (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.typingSpinnerItem }), _jsx("div", { className: styles.typingSpinnerItem }), _jsx("div", { className: styles.typingSpinnerItem })] })) })));
};
